import type { Menu, Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSMenu, useCMSReference } from '@swf/cms';

import CMSMenuGraphProvider from '../../../CMSMenu/CMSMenuGraphProvider';

import styles from './ContextMenu.scss';

interface Props {
  menu: Menu;
  maxDepth: number;
}

interface ItemProps {
  item: Reference;
  maxDepth: number;
}

const ContextMenuItem: React.FC<ItemProps> = ({ item, maxDepth }) => {
  const menu = useCMSReference<Menu>(item);

  return menu ? (
    <CMSMenu
      menu={menu}
      depth={0}
      maxDepth={maxDepth}
      internalItem={styles.navItem}
      activeItem={styles.navItemActive}
      arrowButton={styles.arrowButton}
      arrowButtonActive={styles.arrowButtonActive}
      collapsedList={styles.navItemActive}
    />
  ) : null;
};

const ContextMenu: React.FC<Props> = ({ menu, maxDepth }) => {
  const { uid, children: subMenu } = menu;

  return uid ? (
    <nav className={styles.nav}>
      <CMSMenuGraphProvider menu={menu} maxDepth={maxDepth}>
        <ul className={styles.navList}>
          <li key={menu.uid}>
            <CMSMenu
              menu={menu}
              depth={0}
              maxDepth={0}
              internalItem={styles.navItem}
              activeItem={styles.navItemActive}
            />
          </li>
          {subMenu.map((item) => (
            <li key={item.uid}>
              <ContextMenuItem item={item} maxDepth={maxDepth} />
            </li>
          ))}
        </ul>
      </CMSMenuGraphProvider>
    </nav>
  ) : null;
};
export default ContextMenu;
